const FILTER_SEARCH = {
  FILTER_TYPES: {
    MULTI_OPTION: 'MULTI_OPTION',
    SINGLE_OPTION: 'SINGLE_OPTION',
    RANGE: 'RANGE',
    CUSTOM: 'CUSTOM'
  },
  SORT_TYPES: {
    RELEVANCE: 'relevance',
    PRICE_ASC: 'price_asc',
    PRICE_DESC: 'price_desc',
    NAME_ASC: 'name_asc',
    NAME_DESC: 'name_desc',
    RATING_ASC: 'rating_asc',
    RATING_DESC: 'rating_desc',
    NEW_ARRIVAL_ASC: 'new_arrival_asc',
    NEW_ARRIVAL_DESC: 'new_arrival_desc'
  }

}

export default FILTER_SEARCH